import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import AdaptImage from './AdaptImage'

const copy = {
  overline: `Adapt`,
  heading: `How you adapt to changes in your business or industry`,
  description: `Adaptable customer data means it’s universally accessible, and easy to manage and change as new technologies emerge.`,
}

const Adapt = () => (
  <SectionBase variant="2Col" reverse={true}>
    <SectionCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Overline>{copy.overline}</CopyText.Overline>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        <CopyText.Description variant="pLarge" tag="p">
          {copy.description}
        </CopyText.Description>
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <AdaptImage />
    </Section.Contents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
  }
`

export default Adapt
